export const SET_CURRENT_FLOW = 'SET_CURRENT_FLOW';
export const SET_FLOW_VARIABLES = 'SET_FLOW_VARIABLES';
export const ADD_FLOW_VARIABLE = 'ADD_FLOW_VARIABLE';
export const SET_FLOW_NAME = 'SET_FLOW_NAME';
export const MAKE_DIRTY = 'MAKE_DIRTY';
export const RESET_CHANGE_TRACKER = 'RESET_CHANGE_TRACKER';
export const SET_IS_SAVE_FLOW_IN_PROGRESS = 'SET_IS_SAVE_FLOW_IN_PROGRESS';
export const SET_FLOWS = 'SET_FLOWS';
export const SET_FLOW_STATUS = 'SET_FLOW_STATUS';
export const UPDATE_FLOW = 'UPDATE_FLOW';
export const CLEAR_FLOWS_CACHE = 'CLEAR_FLOWS_CACHE';
